import React from "react";

const Footer = () => {
  return (
    <>
      <style>{`
        @import url("https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap");

        /* ===== FOOTER WRAPPER ===== */
        .footer {
          background: #0b1628;
          font-family: "Poppins", sans-serif;
          color: #cbd5e1;
          width: 100%;
          box-sizing: border-box;
        }

        /* ===== TOP BODY ===== */
        .footer-body {
          max-width: 1300px;
          margin: 0 auto;
          padding: 70px 60px 56px;
          display: grid;
          grid-template-columns: 1.6fr 1.4fr 0.8fr 1fr;
          gap: 40px 48px;
          align-items: start;
          box-sizing: border-box;
        }

        /* ===== COL 1 — BRAND ===== */
        .footer-brand-name {
          font-size: 13px;
          font-weight: 700;
          color: #ffffff;
          letter-spacing: 1.4px;
          text-transform: uppercase;
          margin: 0 0 22px;
          padding-bottom: 10px;
          position: relative;
        }

        .footer-brand-desc {
          font-size: 13.5px;
          font-weight: 400;
          line-height: 1.85;
          color: #94a3b8;
          text-align: justify;
          margin: 0;
        }

        /* ===== COLUMN HEADINGS ===== */
        .footer-col-title {
          font-size: 13px;
          font-weight: 700;
          color: #ffffff;
          letter-spacing: 1.4px;
          text-transform: uppercase;
          margin: 0 0 22px;
          padding-bottom: 10px;
          position: relative;
        }

        /* ===== COL 2 — GET IN TOUCH ===== */
        .footer-contact-list {
          list-style: none;
          padding: 0;
          margin: 0;
          display: flex;
          flex-direction: column;
          gap: 16px;
        }

        .footer-contact-list li {
          display: flex;
          align-items: flex-start;
          gap: 10px;
          font-size: 13.5px;
          color: #94a3b8;
          line-height: 1.65;
        }

        .footer-contact-list li .f-icon {
          font-size: 15px;
          margin-top: 1px;
          flex-shrink: 0;
        }

        .footer-contact-list li a {
          color: #94a3b8;
          text-decoration: none;
          transition: color 0.25s;
        }

        .footer-contact-list li a:hover {
          color: #e2e8f0;
        }

        /* ===== COL 3 — EXPLORE ===== */
        .footer-nav-list {
          list-style: none;
          padding: 0;
          margin: 0;
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .footer-nav-list li a {
          font-size: 14px;
          color: #94a3b8;
          text-decoration: none;
          transition: color 0.25s;
          font-weight: 400;
        }

        .footer-nav-list li a:hover {
          color: #e2e8f0;
        }

        /* ===== COL 4 — OFFICE TIME ===== */
        .footer-office-text {
          font-size: 13.5px;
          color: #94a3b8;
          margin: 0 0 6px;
          line-height: 1.5;
        }

        .footer-office-hours {
          font-size: 13.5px;
          color: #cbd5e1;
          font-weight: 500;
          margin: 0 0 24px;
        }

        /* Social icons */
        .footer-socials {
          display: flex;
          gap: 10px;
          flex-wrap: wrap;
          margin-top: 4px;
        }

        .footer-social-btn {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: #1e2d47;
          border: 1px solid rgba(255,255,255,0.1);
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: background 0.25s, transform 0.25s;
          text-decoration: none;
          color: #cbd5e1;
        }

        .footer-social-btn:hover {
          background: #2d3f5e;
          transform: translateY(-2px);
          color: #ffffff;
        }

        .footer-social-btn svg {
          width: 16px;
          height: 16px;
          fill: currentColor;
        }

        /* ===== DIVIDER ===== */
        .footer-divider {
          max-width: 1300px;
          margin: 0 auto;
          border: none;
          border-top: 1px solid rgba(255, 255, 255, 0.08);
        }

        /* ===== BOTTOM BAR ===== */
        .footer-bottom {
          max-width: 1300px;
          margin: 0 auto;
          padding: 20px 60px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 20px;
          flex-wrap: wrap;
          box-sizing: border-box;
        }

        .footer-copyright {
          font-size: 12.5px;
          color: #64748b;
          margin: 0;
        }

        .footer-policy-links {
          display: flex;
          gap: 24px;
          flex-wrap: wrap;
          align-items: center;
        }

        .footer-policy-links a {
          font-size: 12.5px;
          color: #64748b;
          text-decoration: none;
          transition: color 0.25s;
          white-space: nowrap;
        }

        .footer-policy-links a:hover {
          color: #cbd5e1;
        }

        /* ===== TABLET ===== */
        @media (max-width: 1024px) {
          .footer-body {
            grid-template-columns: 1fr 1fr;
            padding: 56px 40px 44px;
            gap: 36px 40px;
          }

          .footer-bottom {
            padding: 18px 40px;
          }
        }

        /* ===== MOBILE ===== */
        @media (max-width: 640px) {
          .footer-body {
            grid-template-columns: 1fr;
            padding: 48px 24px 40px;
            gap: 36px;
          }

          .footer-brand-desc {
            text-align: left;
          }

          .footer-bottom {
            padding: 18px 24px;
            flex-direction: column;
            align-items: flex-start;
            gap: 14px;
          }

          .footer-policy-links {
            gap: 16px;
          }

          .footer-col-title {
            margin-bottom: 18px;
          }
        }

        @media (max-width: 380px) {
          .footer-policy-links {
            gap: 12px;
          }

          .footer-policy-links a {
            font-size: 12px;
          }
        }
      `}</style>

      <footer className="footer">

        {/* ── TOP BODY ── */}
        <div className="footer-body">

          {/* Col 1 — Brand */}
          <div className="footer-col">
            <h2 className="footer-brand-name">The HexaPlay</h2>
            <p className="footer-brand-desc">
              The HexaPlay is India's first private 3D theatre celebration experience,
              created for people who want to celebrate their moments in a truly unforgettable
              way. Whether it's a birthday, anniversary, romantic proposal, movie night, or
              an electrifying gaming experience, The HexaPlay offers a premium private theatre
              with immersive 3D visuals, powerful surround sound, and premium décor — giving
              you a completely private entertainment experience.
            </p>
          </div>

          {/* Col 2 — Get In Touch */}
          <div className="footer-col">
            <h3 className="footer-col-title">Get In Touch</h3>
            <ul className="footer-contact-list">
              <li>
                <span className="f-icon">📍</span>
                <span>
                  1/398, BMR Mall, Rajiv Gandhi Salai (OMR),&nbsp;
                  Navalur, Chennai‑600130
                </span>
              </li>
              <li>
                <span className="f-icon">✉️</span>
                <a href="mailto:contact@hexaplay.com">contact@thehexaplay.com</a>
              </li>
              <li>
                <span className="f-icon">📞</span>
                <a href="tel:+919087775659">+91 90877 75659</a>
              </li>
            </ul>
          </div>

          {/* Col 3 — Explore */}
          <div className="footer-col">
            <h3 className="footer-col-title">Explore</h3>
            <ul className="footer-nav-list">
              <li><a href="/">Home</a></li>
              <li><a href="/AboutUs">About</a></li>
              <li><a href="/Services">Services</a></li>
              <li><a href="/Gallery">Gallery</a></li>
              <li><a href="/EventServices">Outdoor Events</a></li>
              <li><a href="/Gaming">Gaming</a></li>
              <li><a href="/Contact">Contact</a></li>
            </ul>
          </div>

          {/* Col 4 — Office Time */}
          <div className="footer-col">
            <h3 className="footer-col-title">Office Time</h3>
            <p className="footer-office-text">Operating Hours :</p>
            <p className="footer-office-hours">24/7 Monday to Sunday</p>

            {/* Social Icons */}
            <div className="footer-socials">
              {/* Facebook */}
              <a href="https://www.facebook.com/profile.php?id=61587483247837" className="footer-social-btn" aria-label="Facebook">
                <svg viewBox="0 0 24 24"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>
              </a>
              {/* Instagram */}
              <a href="https://www.instagram.com/thehexaplay/" className="footer-social-btn" aria-label="Instagram">
                <svg viewBox="0 0 24 24"><rect x="2" y="2" width="20" height="20" rx="5" ry="5" fill="none" stroke="currentColor" strokeWidth="2"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" fill="none" stroke="currentColor" strokeWidth="2"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
              </a>
              {/* YouTube */}
              <a href="https://www.youtube.com/@thehexaplay" className="footer-social-btn" aria-label="YouTube">
                <svg viewBox="0 0 24 24"><path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46A2.78 2.78 0 0 0 1.46 6.42 29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58 2.78 2.78 0 0 0 1.95 1.96C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 0 0 1.95-1.96A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z"/><polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02" fill="#0b1628"/></svg>
              </a>
              {/* X / Twitter */}
              <a href="https://x.com/thehexaplay?s=11" className="footer-social-btn" aria-label="X">
                <svg viewBox="0 0 24 24"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.748l7.73-8.835L2.25 2.25H8.08l4.262 5.636 5.902-5.636zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
              </a>
            </div>
          </div>

        </div>

        {/* ── DIVIDER ── */}
        <hr className="footer-divider" />

        {/* ── BOTTOM BAR ── */}
        <div className="footer-bottom">
          <p className="footer-copyright">
            © 2026 NP Groups – Private Movie Theaters – All rights reserved
          </p>
          <nav className="footer-policy-links">
            <a href="/refund-policy">Refund Policy</a> 
            <a href="/privacy-policy">Privacy Policy</a>
            <a href="/">Terms &amp; Conditions</a>
            <a href="/cancellation-policy">Cancellation Policy</a>
          </nav>
        </div>

      </footer>
    </>
  );
};

export default Footer;